import * as $               from 'jquery';
import { $body }            from 'Core/Body';
import { Notifications }    from 'Core/Notifications';
import { ReCaptcha }     from 'Core/ReCaptcha';
import 'jquery-validation';

export const ProductAvailable = (() => {

    const Selector = {
        MODAL                       : '#AvailableModal',
        FORM                        : '#availableForm',
        SHOW_MODAL_BUTTON           : '#ShowProductAvailableForm',
        SUBMIT_BUTTON               : '#SubmitProductAvailableForm',
        CAPTCHA_HIDDEN              : '#available_captcha_hidden'
    };

    $(Selector.FORM).validate({
        ignore: '',
        rules: {
            available_first_and_last_name: 'required',
            available_email: 'required',
            available_phone: { minlength: 9, maxlength: 15, required:true },
            available_captcha_hidden: 'required',
            agree_rules: 'required'
        }
    });

    let recaptchaWidgetId:number; //variable for recaptcha widget Id to prepare reset method to use in for this form

    async function createRecaptcha() {
        if($('#g-recaptcha-available-form').children().length == 0) {
       
            let recaptcha = new ReCaptcha();
            let sitekey   = $('.g-recaptcha-available-form').attr('data-sitekey');
            
            recaptchaWidgetId = recaptcha.render(sitekey, 'g-recaptcha-available-form');
        } else {
            captchaResetHandler(); //reset captcha for this form if captcha is rendered yet
        }
    }

    function showAvailableModal() {
        $(Selector.MODAL).modal("show");
    }

    function submitAvailableModal() {
        let $response = true;

        if($('.g-recaptcha-available-form').find('.g-recaptcha-response').val() ) {
            $response = true;
        } else {
            $response = false;
            Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
        }

        if($(Selector.FORM).valid() && $response) {
            $.post($(Selector.FORM).attr('action'), $(Selector.FORM).serialize(), res => {
                $(Selector.FORM + ' p.invalid-feedback').remove();

                let $result = {
                    status: null,
                    msg: null,
                    error: []
                };
                try {
                    $result = JSON.parse(res);
                } catch (e) {
                    Notifications.add('Wystąpił nieokreślony błąd', "error", {lifespan: 10000});
                }

                if($result.status === "success") {
                    Notifications.add($result.msg, "info", {lifespan: 10000});
                    captchaResetHandler();
                    $(Selector.FORM).find('input[type="text"]').val(null);
                    $(Selector.FORM).find('textarea').val(null);
                    $(Selector.FORM).find('input[type="checkbox"]').prop('checked', false);
                    $(Selector.MODAL).modal("hide");
                }
                else {
                    Notifications.add($result.msg, "error", {lifespan: 10000});
                    captchaResetHandler();

                    if($result.error != undefined) {
                        $($result.error).each(function (index, err) {
                            $(Selector.FORM + ' #'+err.input).after('<p class="invalid-feedback" style="display: block">'+err.msg+'</p>')
                        });
                    }
                }
            });
        }

    }

    function captchaResetHandler() {
        grecaptcha.reset(recaptchaWidgetId); //reset captcha based on  recaptchaWidgetId --> id of captcha for this form
    }

    $body.on('click', Selector.SHOW_MODAL_BUTTON, showAvailableModal);
    $body.on('click', Selector.SUBMIT_BUTTON, submitAvailableModal);
    $('#AvailableModal').on('shown.bs.modal', createRecaptcha);
    
})();
import * as $               from 'jquery';
import { $body }            from 'Core/Body';
import { Notifications }    from 'Core/Notifications';
import { ReCaptcha }     from 'Core/ReCaptcha';
import 'jquery-validation';

export const ProductAvailable = (() => {

    const Selector = {
        MODAL                       : '#AvailableModal',
        FORM                        : '#availableForm',
        SHOW_MODAL_BUTTON           : '#ShowProductAvailableForm',
        SUBMIT_BUTTON               : '#SubmitProductAvailableForm',
        CAPTCHA_HIDDEN              : '#available_captcha_hidden'
    };

    $(Selector.FORM).validate({
        ignore: '',
        rules: {
            available_first_and_last_name: 'required',
            available_email: 'required',
            available_phone: { minlength: 9, maxlength: 15, required:true },
            available_captcha_hidden: 'required',
            agree_rules: 'required'
        }
    });

    let recaptchaWidgetId:number; //variable for recaptcha widget Id to prepare reset method to use in for this form

    async function createRecaptcha() {
        if($('#g-recaptcha-available-form').children().length == 0) {
       
            let recaptcha = new ReCaptcha();
            let sitekey   = $('.g-recaptcha-available-form').attr('data-sitekey');
            
            recaptchaWidgetId = recaptcha.render(sitekey, 'g-recaptcha-available-form');
        } else {
            captchaResetHandler(); //reset captcha for this form if captcha is rendered yet
        }
    }

    function showAvailableModal() {
        $(Selector.MODAL).modal("show");
    }

    function submitAvailableModal() {
        let $response = true;

        if($('.g-recaptcha-available-form').find('.g-recaptcha-response').val() ) {
            $response = true;
        } else {
            $response = false;
            Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
        }

        if($(Selector.FORM).valid() && $response) {
            $.post($(Selector.FORM).attr('action'), $(Selector.FORM).serialize(), res => {
                $(Selector.FORM + ' p.invalid-feedback').remove();

                let $result = {
                    status: null,
                    msg: null,
                    error: []
                };
                try {
                    $result = JSON.parse(res);
                } catch (e) {
                    Notifications.add('Wystąpił nieokreślony błąd', "error", {lifespan: 10000});
                }

                if($result.status === "success") {
                    Notifications.add($result.msg, "info", {lifespan: 10000});
                    captchaResetHandler();
                    $(Selector.FORM).find('input[type="text"]').val(null);
                    $(Selector.FORM).find('textarea').val(null);
                    $(Selector.FORM).find('input[type="checkbox"]').prop('checked', false);
                    $(Selector.MODAL).modal("hide");
                }
                else {
                    Notifications.add($result.msg, "error", {lifespan: 10000});
                    captchaResetHandler();

                    if($result.error != undefined) {
                        $($result.error).each(function (index, err) {
                            $(Selector.FORM + ' #'+err.input).after('<p class="invalid-feedback" style="display: block">'+err.msg+'</p>')
                        });
                    }
                }
            });
        }

    }

    function captchaResetHandler() {
        grecaptcha.reset(recaptchaWidgetId); //reset captcha based on  recaptchaWidgetId --> id of captcha for this form
    }

    $body.on('click', Selector.SHOW_MODAL_BUTTON, showAvailableModal);
    $body.on('click', Selector.SUBMIT_BUTTON, submitAvailableModal);
    $('#AvailableModal').on('shown.bs.modal', createRecaptcha);
    
})();
